import {h, Fragment} from "preact"
// import { useSizeOptions } from "@nosto/preact"
// import { defaultConfig, sizes } from "../config"
// import Pagination from "./Pagination"
// import Select from "./elements/Select"

// export default function BottomToolbar() {
//     const { from, to, size, total, handleSizeChange, sizeOptions } = useSizeOptions(sizes, defaultConfig.serpSize)

//     const options = sizeOptions.map(v => ({ value: v, label: `${v} items per page` }))

//     return (
//         <div class="ns-bottom-toolbar">
//             <Pagination />
//         </div>
//     )
// }

import { useSizeOptions } from "@nosto/preact"
import { defaultConfig, sizes } from "../config"
import Pagination from "./Pagination"
import {SelectPerPage} from "./elements/Select"

export default function BottomToolbar() {
    const { from, to, size, total, handleSizeChange, sizeOptions } = useSizeOptions(sizes, defaultConfig.serpSize)

    const options = sizeOptions.map(v => ({ value: v, label: `${v} items per page` }))

    return (
        <div class="ns-bottom-toolbar">
            {/* <div class="ns-per-page-wrapper">
                {sizeOptions.length > 0 && (
                    <SelectPerPage
                        value={size}
                        onChange={e => handleSizeChange(e.target.value)}
                        className="ns-per-page-select"
                        options={options}
                    />
                )}
            </div> */}
            <Pagination />
        </div>
    )
}